import { EventCatalogFromKeys, EventType } from "../../../types";

export const VolunteerRecruitmentEventKeys = {
  VOLUNTEER_RECRUITMENT_CLIENT_EXPORT: "volunteer-recruitment-client-export",
  VOLUNTEER_RECRUITMENT_COPY_LINK: "volunteer-recruitment-copy-link",
  VOLUNTEER_RECRUITMENT_OPEN_LINK: "volunteer-recruitment-open-link",
} as const;

export const VolunteerRecruitmentEventCatalog: EventCatalogFromKeys<
  typeof VolunteerRecruitmentEventKeys
> = {
  [VolunteerRecruitmentEventKeys.VOLUNTEER_RECRUITMENT_COPY_LINK]: {
    description:
      "User copied the volunteer recruitment link in VolunteerRecruitmentCard",
    eventType: EventType.INTERACTION,
    id: VolunteerRecruitmentEventKeys.VOLUNTEER_RECRUITMENT_COPY_LINK,
  },
  [VolunteerRecruitmentEventKeys.VOLUNTEER_RECRUITMENT_OPEN_LINK]: {
    description:
      "User opened the volunteer recruitment link in VolunteerRecruitmentCard",
    eventType: EventType.INTERACTION,
    id: VolunteerRecruitmentEventKeys.VOLUNTEER_RECRUITMENT_OPEN_LINK,
  },
  [VolunteerRecruitmentEventKeys.VOLUNTEER_RECRUITMENT_CLIENT_EXPORT]: {
    description: "User exported data in VolunteerRecruitmentClient",
    eventType: EventType.INTERACTION,
    id: VolunteerRecruitmentEventKeys.VOLUNTEER_RECRUITMENT_CLIENT_EXPORT,
  },
};
